import React from "react";
import { useToast } from "./ToastContext";
import { Toast } from "./Toast";

/**
 * ToastContainer Component
 *
 * Renders all active toasts in a fixed container at the top-right of the screen.
 * Should be placed once at the root level of your app (typically in App.tsx or layout).
 */
export const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onDismiss={hideToast} />
        </div>
      ))}
    </div>
  );
};
